import { _ as _objectSpread2, b as _objectWithoutProperties } from './slicedToArray-1793c995.esm.js';
import _omit from 'ramda/src/omit';
import _evolve from 'ramda/src/evolve';
import { extendTheme, theme as theme$1, ChakraProvider } from '@chakra-ui/react';
import { c as components } from './index-4003094f.esm.js';
export { m as mapResponsive, a as mergeSizesToResponsive, r as reduceResponsive } from './index-4003094f.esm.js';
import { c as configuration } from './transitions-b88a8e42.esm.js';
export { a as cssVarPrefixed, v as variables } from './transitions-b88a8e42.esm.js';
import { f as foundations } from './index-bf58ad9a.esm.js';
import 'react';
import { jsx } from '@emotion/react/jsx-runtime';
import '@hover/blueprint-theme';
import 'ramda/src/pick';
import '@hover/blueprint-theme/components';
import '@hover/utilities';
import 'ramda/src/mergeDeepRight';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import './toConsumableArray-dba89f3e.esm.js';
import 'ramda/src/mergeDeepWith';
import 'polished';
import '@hover/tokens-typography';
import './focus-2f6da0d4.esm.js';
import './text-1fc26d72.esm.js';
import './space-897bc55c.esm.js';
import './menu-5c1119be.esm.js';
import '@chakra-ui/anatomy';
import '@emotion/react';
import 'ramda/src/max';
import 'ramda/src/reduce';
import './textStyles-e38f5da1.esm.js';

/**
 * Tokens to omit
 */
var foundationsToOmit = ['breakpoints', 'radii', 'space', 'sizes', 'shadows'];

/**
 * List of components to omit from the base theme. These components will not
 * receive any theming from Chakra, and instead will be themed entirely in this
 * theme. This is useful for cases where we find ourselves overwriting portions
 * of the Chakra theme just to disable the default appearance.
 */
var componentsToOmit = ['Alert', 'AlertDialog', 'Button', 'Checkbox', 'Code', 'Drawer', 'FormError', 'FormLabel', 'Heading', 'Input', 'Kbd', 'Link', 'List', 'Menu', 'Modal', 'PinInput', 'Popover', 'Progress', 'Radio', 'Select', 'Tabs', 'Tag', 'Text', 'Textarea'];
var baseTheme = /*#__PURE__*/_evolve({
  components: /*#__PURE__*/_omit(componentsToOmit)
}, theme$1);
foundationsToOmit.forEach(function (foundation) {
  // @ts-expect-error
  baseTheme[foundation] = {};
});
var theme = /*#__PURE__*/extendTheme( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, foundations), {}, {
  components: components
}), baseTheme);
theme.config = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, theme.config), configuration);
theme.styles.global = {};

var _excluded = ["children", "resetCSS"];
var Provider = function Provider(_ref) {
  var children = _ref.children,
    _ref$resetCSS = _ref.resetCSS,
    resetCSS = _ref$resetCSS === void 0 ? false : _ref$resetCSS,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(ChakraProvider, _objectSpread2(_objectSpread2({}, props), {}, {
    resetCSS: resetCSS,
    theme: theme,
    children: children
  }));
};

export { Provider, theme };
